import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UNGROUPED } from './faqOptions'

// Actions on the selected rows of the current page: move to a group, or delete.
export default function FaqBulkBar({ count, groups, busy, onSetGroup, onDelete, onClear }) {
  const { t, i18n } = useTranslation()
  const [chosen, setChosen] = useState('')
  if (count === 0) return null
  const formatted = Number(count).toLocaleString(i18n.language)
  // A group deleted meanwhile is no longer a target.
  const target = chosen === UNGROUPED || groups.some((group) => group.id === chosen) ? chosen : ''

  return (
    <div role="region" aria-label={t('faq.bulk.label')} className="flex flex-wrap items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2 text-sm">
      <span className="font-semibold text-slate-900">{t('faq.list.selected', { count, formatted })}</span>
      <select
        value={target}
        onChange={(event) => setChosen(event.target.value)}
        aria-label={t('faq.bulk.targetGroup')}
        className="h-9 rounded-lg border border-slate-200 bg-white px-2"
      >
        <option value="">{t('faq.bulk.chooseGroup')}</option>
        {groups.map((group) => (
          <option key={group.id} value={group.id}>{group.name}</option>
        ))}
        <option value={UNGROUPED}>{t('faq.ungrouped')}</option>
      </select>
      <button
        type="button"
        disabled={busy || !target}
        onClick={() => {
          setChosen('')
          onSetGroup(target === UNGROUPED ? null : target)
        }}
        className="h-9 rounded-lg border border-slate-200 bg-white px-3 font-medium disabled:cursor-not-allowed disabled:opacity-50"
      >
        {t('faq.bulk.setGroup')}
      </button>
      <button
        type="button"
        disabled={busy}
        onClick={() => {
          // A hard delete: there is no trash to restore from.
          if (window.confirm(t('faq.bulk.deleteConfirm', { count, formatted }))) onDelete()
        }}
        className="h-9 rounded-lg border border-red-200 bg-white px-3 font-medium text-red-600 disabled:opacity-50"
      >
        {t('faq.bulk.delete')}
      </button>
      <button type="button" onClick={onClear} className="ml-auto text-slate-500 underline underline-offset-2">
        {t('faq.bulk.clear')}
      </button>
    </div>
  )
}
